/**
 * A requisição não pôde nem ser tentada — sem conectividade, DNS, CORS
 * bloqueado etc. (`fetch()` só rejeita nesses casos; respostas HTTP de erro,
 * 4xx/5xx, resolvem normalmente com `response.ok === false` e não passam por
 * aqui). Distinto de um erro genérico (achado do Tech Lead, review do PR
 * #85, HUB-235): sem cache válido para a estratégia Network First recorrer,
 * este é o cenário "offline, aguardando conexão" do Design da spec — nunca
 * deve virar uma mensagem de erro técnica (ex. "Failed to fetch") na caixa
 * vermelha da `ConfigLoadingScreen`.
 */
export class NetworkUnavailableError extends Error {
  constructor() {
    super('Sem conexão com a rede.');
    this.name = 'NetworkUnavailableError';
  }
}
